let environment = "PRODUCTION";
let appUrl = `//${document.location.host}/`;
if (appUrl.endsWith(":3000/")) {
  appUrl = "//riparti-api.ddev.site/";
  environment = "DEVELOPER";
} else if (document.location.href.indexOf("/candidatura-staging") !== -1) {
  appUrl = `//${appUrl}candidatura-staging/`;
} else if (document.location.href.indexOf("/candidatura") !== -1) {
  appUrl = `//${appUrl}candidatura/`;
}

let recaptchaSiteKey = "";
switch (appUrl) {
  case "//riparti.regione.puglia.it/candidatura-staging/":
    recaptchaSiteKey = "6Ld7GUsgAAAAAN5iUpyRa06nl3uHcSUB8434mxla";
    break;
  case "//riparti.regione.puglia.it/candidatura/":
    recaptchaSiteKey = "6LeIMcYgAAAAAEKE21BRAv3kkN7IpctbYqWiYG0J";
    break;
  case "//centririsorse.local/":
  default:
    recaptchaSiteKey = "6LekNssfAAAAABcnZL0o-OmJPRUc52L8lxYz_dex";
    break;
}
export const APP_URL = appUrl;
export const API_URL = `${APP_URL}api`;
export const SIGNUP_URL = `${APP_URL}signup/`;
export const VERSION = "1.0.10";
export const ENVIRONMENT = environment;
export const DRAWER_WIDTH = 250;
export const MAX_FILE_SIZE = 100000000; // 20 MB
export const ACCEPTED_FILE_MEDIA_TYPES = [
  ".gif",
  ".png",
  ".jpg",
  ".jpeg",
  ".bmp",
];
export const ACCEPTED_DOCS_TYPES = [".p7m", ".pdf"];
export const ACCEPTED_DOCS_ID_TYPES = [".pdf", ".jpeg", ".zip"];
export const ACCEPTED_FILE_TYPES = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".ppt",
  ".pptx",
  ".zip",
  ".p7m",
].concat(ACCEPTED_FILE_MEDIA_TYPES);

export const APP_TITLE = "Riparti";
export const RECAPTCHA_SITE_KEY = recaptchaSiteKey;
